import * as tslib_1 from "tslib";
import * as React from 'react';
import { observer } from 'mobx-react';
import { Link } from 'office-ui-fabric-react/lib/Link';
import { getHelpUrl } from 'owa-help';
import strings from 'owa-strings/owa-options-strings';
var HELP_WINDOW_NAME = 'o365Help';
var HELP_WINDOW_OPTIONS = 'width=400,height=500,menubar=no,status=no,scrollbars=no,titlebar=no,toolbar=no,resizable=yes';
var HelpLink = /** @class */ (function (_super) {
    tslib_1.__extends(HelpLink, _super);
    function HelpLink() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onHelpLink = function (ev) {
            ev.preventDefault();
            window.open(getHelpUrl(_this.props.helpId), HELP_WINDOW_NAME, HELP_WINDOW_OPTIONS);
        };
        return _this;
    }
    HelpLink.prototype.render = function () {
        return (React.createElement(Link, { href: getHelpUrl(this.props.helpId), target: HELP_WINDOW_NAME, onClick: this.onHelpLink }, strings.options_mail_linkPreviewHelpLink));
    };
    HelpLink = tslib_1.__decorate([
        observer
    ], HelpLink);
    return HelpLink;
}(React.Component));
export default HelpLink;
//# sourceMappingURL=HelpLink.js.map